import { Observable, of } from 'rxjs';
import { TemplateFunctionsModel } from 'src/app/shared/models/template-functions';
import { IdsStepsAppointmentWizardModel } from 'src/app/shared/models/idsStepsAppointmentWizard.model';

export function templateProfessionalsActionButtonDisabled({
    flowwwerTemplate,
}: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templateProfessionalsStepCheckShowActionButton({
    flowwwerTemplate,
}: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templateProfessionalsNextStep({
    flowwwerTemplate,
}: TemplateFunctionsModel): void {
    return flowwwerTemplate();
}

export function templateGoBackSlideProfessional({
    flowwwerTemplate,
}: TemplateFunctionsModel): boolean {
    return flowwwerTemplate();
}

export function templateProfessionalUndoNextStep({
    flowwwerTemplate,
}: TemplateFunctionsModel): void {
    return flowwwerTemplate();
}

export function templateDatetimeStepCheckShowActionButton({
    flowwwerTemplate,
}: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templateDatetimeActionButtonDisabled({
    flowwwerTemplate,
}: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templatePaymethodsStepCheckShowActionButton({
    flowwwerTemplate,
}: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templatePaymethodsActionButtonDisabled({
    flowwwerTemplate,
}: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templatePaymethodUndoNextStep({
    flowwwerTemplate,
}: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templateResultStepCheckShowActionButton({
    flowwwerTemplate,
}: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

const FAMILIES = IdsStepsAppointmentWizardModel.FAMILIES;
const PROFESSIONALS = IdsStepsAppointmentWizardModel.PROFESSIONALS;
const DATETIME = IdsStepsAppointmentWizardModel.DATETIME;
const SOCIAL_LOGIN = IdsStepsAppointmentWizardModel.SOCIAL_LOGIN;
const REGISTER = IdsStepsAppointmentWizardModel.REGISTER;
const CONFIRM = IdsStepsAppointmentWizardModel.CONFIRM;
const PAYMETHODS = IdsStepsAppointmentWizardModel.PAYMETHODS;
const PAYMENT = IdsStepsAppointmentWizardModel.PAYMENT;
const RESULT = IdsStepsAppointmentWizardModel.RESULT;

export const stepsLabels = {
    FAMILIES: 'app_ask_sched_step_1_title',
    PROFESSIONALS: 'app_ask_sched_step_1b_title',
    DATETIME: 'app_ask_sched_step_2_title',
    SOCIAL_LOGIN: 'app_registration_title_header',
    REGISTER: 'app_registration_title_header',
    CONFIRM: 'app_sched_ask',
    PAYMETHODS: 'app_buy_step_2_title',
    PAYMENT: 'app_buy_step_3_title',
    RESULT: 'app_appointment_result_step_title',
};
